import {SubjectEntity} from "./SubjectEntity";
import {TopicEntity} from "./TopicEntity";

export class TutorFollowupEntity {
  corpId: number;
  id: number;
  subscriptionId: number;
  tutorId: number;
  note: string;
  nextContact: string;
  notifyStudent: boolean;
  created: string;
}
